import axios from "axios";

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "",
  headers: { "Content-Type": "application/json" },
});

// Inject microsite context headers on every public request
publicApi.interceptors.request.use((config) => {
  const tenantId = localStorage.getItem("public_tenant_id");
  const micrositeId = localStorage.getItem("public_microsite_id");
  if (tenantId) config.headers["X-Tenant-ID"] = tenantId;
  if (micrositeId) config.headers["X-Microsite-ID"] = micrositeId;

  // Auto-inject `lang` query param for Spanish tenant microsite routes.
  // Matches: "/es", "/es/*", "/s/<sub>/es", "/s/<sub>/es/*", plus explicit "?lang=es".
  // Safe: never overwrites an explicit `lang` supplied by the caller.
  try {
    if (typeof window !== "undefined") {
      const path = window.location.pathname || "";
      const search = window.location.search || "";
      const segs = path.split("/").filter(Boolean);
      const idx = segs[0] === "s" ? 2 : 0;
      const langSeg = segs[idx];
      const explicit = /(?:\?|&)lang=es(?:&|$)/.test(search);
      if (langSeg === "es" || explicit) {
        config.params = config.params || {};
        if (!("lang" in config.params)) config.params.lang = "es";
      }
    }
  } catch { /* noop */ }
  return config;
});

// Pages
export const getPublishedPages = () => publicApi.get("/api/public/site/pages");
export const getHomepage = () => publicApi.get("/api/public/site/pages/home");
export const getPageBySlug = (slug) => publicApi.get(`/api/public/site/pages/${slug}`);

// Branding & Theme
export const getBranding = () => publicApi.get("/api/public/site/branding");
export const getDeliveryWindows = (eventDate) => publicApi.get("/api/public/booking/delivery-windows", { params: eventDate ? { event_date: eventDate } : {} });
export const getTheme = () => publicApi.get("/api/public/site/theme");

// Public catalog (for data-bound blocks)
// Catalog — adds microsite_id for independent catalog filtering
const withMicrositeId = (params = {}) => {
  const mid = localStorage.getItem("public_microsite_id");
  return mid ? { ...params, microsite_id: mid } : params;
};
export const getPublicItems = (params) => publicApi.get("/api/public/catalog/items", { params: withMicrositeId(params) });
export const getPublicItemBySlug = (slug, params) => publicApi.get(`/api/public/catalog/items/${slug}`, { params });
export const getPublicCategories = (params) => publicApi.get("/api/public/catalog/categories", { params: withMicrositeId(params) });
export const getPublicPackages = (params) => publicApi.get("/api/public/catalog/packages", { params });
export const getPublicDateAvailability = (params) => publicApi.get("/api/public/catalog/availability", { params });

// Public reviews
export const getPublicReviews = (params) => publicApi.get("/api/reviews", { params });

// Preview auto-detect (development)
export const getPreviewSetup = () => publicApi.get("/api/public/site/preview-setup");

// Public availability (blackout + booked dates for an item)
export const getPublicAvailability = (itemId) => publicApi.get(`/api/public/site/availability/${itemId}`);

export default publicApi;
